import { render, staticRenderFns } from "./ItemSkuList.vue?vue&type=template&id=0a33ff74&scoped=true&"
import script from "./ItemSkuList.vue?vue&type=script&lang=js&"
export * from "./ItemSkuList.vue?vue&type=script&lang=js&"
import style0 from "./ItemSkuList.vue?vue&type=style&index=0&id=0a33ff74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a33ff74",
  null
  
)

export default component.exports